<template>
  <transition name="modal">
    <div class="modal-background" @click.self="$store.commit('hideProfileMenu')">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container" @click.self.prevent="">
            <div class="modal-close grow" @click="$store.commit('hideProfileMenu')">
              <i class="material-icons">close</i>
            </div>
            <div class="modal-title">{{ name }}</div>
            <div class="options">
              <div class="option" @click="clickSettings">Account Settings</div>
              <div class="option" @click="clickHelp">Contact Support</div>
              <div class="option" @click="clickLogOut">Log Out</div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Back from "../../modules/Back";
import Cookies from "js-cookie";

export default {
  name: "ProfileMenu",
  components: {},
  props: [],
  data: function() {
    return {
      name: this.$store.state.user.name
    };
  },
  methods: {
    clickHelp() {
      window.Intercom("show");
    },
    clickSettings() {
      window.location.href = process.env.VUE_APP_ACCOUNT_URL + "/settings";
    },
    clickLogOut() {
      Cookies.remove("auth-token");
      window.location.href = process.env.VUE_APP_ACCOUNT_URL + "/logout";
    }
  }
};
</script>

<style lang="scss" scoped>
.options {
  margin: 16px 6px 0px 6px;

  .option {
    cursor: pointer;
    color: #555;
    font-size: 13pt;
    padding: 0.5em 1.25em;
    border-radius: 60px;
  }
  .option:hover {
    background: #f3f3f3;
    color: $color-blue;
  }
}

.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  z-index: 10;
}

.modal-title {
  padding-top: 4px;
  padding-left: 64px;
  font-size: 15pt;
  font-weight: 600;
  color: #111;
  text-align: center;
}
.modal-instructions {
  font-size: 12pt;
  color: #111;
  text-align: center;
}
.modal-close {
  font-size: 15pt;
  margin-right: 6px;
  padding: 7px 0 0 6.5px;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  float: right;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.modal-close:hover {
  background: #eee;
  transform: scale(1.1);
  cursor: pointer;
}

.find-book {
  background: #fff;
  box-shadow: 0 0 1.5rem rgba(0, 0, 0, 0.14);
  font-family: $font-family;
}

.actions {
  padding: 4px;
  text-align: center;
}
.action {
  background: #ede7f6;
  color: #9575cd;
}

.confirm-text {
  padding: 0.75em 0 0 0;
  font-size: 11.5pt;
  color: #333;
  text-align: center;
}
.points-text {
  color: darken(#ffa000, 6%);
  font-weight: 700;
}
.book-title {
  color: $color-blue;
  font-weight: 700;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 54px;
  left: 75%;
  width: 25%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  display: table;
  transition: opacity 0.3s ease;
}

@media (max-width: 1024px) {
  .modal-mask {
    left: 40%;
    width: 60%;
  }
}

.modal-wrapper {
  display: table-cell;
  vertical-align: right;
  z-index: 100000;
}

.modal-container {
  z-index: 999999;
  max-width: 1060px;

  margin: 0px auto;
  padding: 20px 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.19);
  transition: all 0.3s ease;
  font-family: "Source Sans Pro";
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


